<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="角色名称">
          <Input class="w-250" v-model="table.search.UserRoleName"></Input>
        </FormItem>
        <FormItem label="角色编码">
          <Input class="w-250" v-model="table.search.UserRoleCode"></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal=true">新增</Button>
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal v-model="addModal" title="新增角色" :footer-hide="true" :closable="false">
      <roleadd @close="addModal=false" @loadData="search"></roleadd>
    </Modal>

    <!--更新-->
    <Modal v-model="editModal" title="更新角色" :footer-hide="true" :closable="false">
      <roleedit
        v-if="editModal"
        @close="editModal=false"
        @loadData="search"
        :editModelTemp="currentEditModel"
      ></roleedit>
    </Modal>

    <!--详情-->
    <Modal v-model="detailModal" title="角色详情" :footer-hide="true" :closable="false">
      <roledetail v-if="detailModal" @close="detailModal=false" :editModelTemp="currentEditModel"></roledetail>
    </Modal>

    <!--分配权限-->
    <Modal width="60%" v-model="setPrivilegeModal" title="分配权限" :footer-hide="true">
      <setNormalPrivilege
        v-if="setPrivilegeModal"
        @close="setPrivilegeModal=false"
        :editModelTemp="currentEditModel"
      ></setNormalPrivilege>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import roleadd from "../role/add.vue";
import roleedit from "../role/edit.vue";
import roledetail from "../role/detail.vue";
import setNormalPrivilege from "../role/setNormalPrivilege.vue";

export default {
  components: { DataTable, roleadd, roleedit, roledetail, setNormalPrivilege },
  data: function () {
    return {
      currentEditModel: {},
      setPrivilegeModal: false,
      detailModal: false,
      addModal: false,
      editModal: false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "角色名称", key: "userRoleName" },
          { title: "角色编码", key: "userRoleCode" },
          { title: "所属机构", key: "organName" },
          {
            title: "创建时间",
            key: "createTime",
            render: (h, value) => {
              return h("div", this.$common.parseDate(value.row.createTime));
            },
          },
          {
            title: "操作",
            width: "300px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toSetPrivilege(params.row);
                      },
                    },
                  },
                  "分配权限"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.userRoleID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "role/getListPage",
        search: {
          UserRoleName: "",
          UserRoleCode: "",
        },
      },
    };
  },

  created: function () {},
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },

    //分配功能权限
    toSetPrivilege: function (data) {
      this.setPrivilegeModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },


    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该权限吗？",
        mask: false,
        onOk: () => {
          this.$api.post(`/role/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.userRoleID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api.post(`/role/deleteBatch?ids=${_ids}`).then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
          },
        });
      }
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>